import activateExitPop from '../../js-modules/exit-intent-handler.js';
// import runDiscountTimer from "../../js-modules/timer.js";
// import videoThumbLazy from "../../js-modules/video-thumb-lazy.js";
import ReviewsController from '../../js-modules/amazCustomerReview.js';
import runDiscountTimer from "../../js-modules/timer.js";

window.addEventListener('DOMContentLoaded', () => {
    activateExitPop({
        popupID: 'exit-intent',
        delay: 60,
        extraDelayTime: 20,
        maxAttempts: 2,
    })

    document.querySelectorAll('.customer-reviews__wrapper')
        .forEach(wrapper => {
            new ReviewsController(wrapper);
        });

    const timerEls = document.getElementsByClassName('discount-timer');
    for (const timer of timerEls) {
        runDiscountTimer(timer, 1800);
    }

    // const lazyVideos = document.querySelectorAll('.video.lazy');
    // videoThumbLazy(lazyVideos)

    document.querySelectorAll('.accordion .accordion__item')
        .forEach(item => item.addEventListener('click', function (e) {
            e.currentTarget.classList.toggle('active')
        }))

    const prePurchaseBtns = document.getElementsByClassName('pre-purchase')
    const prePurchasePop = document.getElementById('pre-purchase-popup')
    if (prePurchasePop) {
        const prePurchasePopCloseBtn = prePurchasePop.getElementsByClassName('close-btn')[0]

        for (let prePurchaseBtn of prePurchaseBtns) {
            prePurchaseBtn.addEventListener('click', function (e) {
                e.preventDefault()
                if (!prePurchasePop) {
                    window.location(prePurchaseBtn.getAttribute('href'))
                    return false
                }

                prePurchasePop.classList.add('active')
                prePurchasePopCloseBtn.addEventListener('click', function () {
                    prePurchasePop.classList.remove('active')
                }, false)
            })
        }
    }

    const sendRequest = (url, data) => {
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(data),
        }).then(response => {
            if (!response.ok) {
                return response.json()
                    .catch(() => ({}))
                    .then(err => Promise.reject(err));
            }
            return response.json();
        });
    };

    const apiErrorMessage = err => {
        if (!err?.error) return '';
        const validationMsg = err.messages && Object.values(err.messages).flat()[0];
        const msg = validationMsg || err.message;
        // "Maropost API error" and friends are technical noise, not user-facing messages
        return typeof msg === 'string' && !msg.includes('Maropost') ? msg : '';
    };

    const form = document.getElementById('exitpop-form');

    if (form) {
        const subBtn  = form.querySelector('.submit-btn');
        const errorEl = form.querySelector('.error-msg');
        const fEmail  = form.querySelector('.email-input');
        const labels  = form.querySelectorAll('label');

        const resetErrors = () => {
            labels.forEach(l => l.classList.remove('invalid'));
            errorEl.textContent = '';
            errorEl.style.display = 'none';
        };

        const showError = msg => {
            errorEl.textContent = msg;
            errorEl.style.display = 'block';
        };

        form.addEventListener('submit', e => {
            e.preventDefault();
            resetErrors();

            if (!isValidEmail(fEmail.value)) {
                const label = fEmail.closest('label') || fEmail.previousElementSibling;
                label?.classList.add('invalid');
                showError('Please enter a valid email address.');
                return;

            }

            subBtn.disabled = true;

            sendRequest('https://thecontestleaderboard.com/api/mp-service/add-subscriber', {
                email: fEmail.value,
                last_name: '',
                list_id: 17,
                tags: ['pinealguardian_exitpop_discount']
            })
                .then(() => {
                    form.closest('.exit-intent')?.removeAttribute('id');
                })
                .catch(err => {
                    showError(apiErrorMessage(err) || 'Something went wrong. Please try again.');
                })
                .finally(() => subBtn.disabled = false);
        });
    }

    function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    const copyToClipboard = async text => {
        if (navigator.clipboard && window.isSecureContext) {
            try {
                await navigator.clipboard.writeText(text);
                return true;
            } catch (err) {
                console.warn('Clipboard API failed, falling back to execCommand', err);
            }
        }

        const helper = document.createElement('textarea');
        helper.value = text;
        helper.setAttribute('readonly', '');
        helper.style.position = 'fixed';
        helper.style.top = '-9999px';
        helper.style.opacity = '0';
        document.body.appendChild(helper);
        helper.select();
        helper.setSelectionRange(0, helper.value.length);

        let copied = false;
        try {
            copied = document.execCommand('copy');
        } catch (err) {
            console.warn('Copy fallback failed', err);
        }

        document.body.removeChild(helper);
        return copied;
    };

    let toastTimer;
    const showToast = message => {
        let toast = document.querySelector('.toast');
        if (!toast) {
            toast = document.createElement('div');
            toast.className = 'toast';
            toast.setAttribute('role', 'status');
            toast.setAttribute('aria-live', 'polite');
            document.body.appendChild(toast);
        }

        toast.textContent = message;
        // Force reflow so re-triggering restarts the enter transition
        void toast.offsetWidth;
        toast.classList.add('show');

        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => toast.classList.remove('show'), 2500);
    };

    const exitPop = document.querySelector('.modal-wrapper.exit-intent');
    const tySection = exitPop?.querySelector('.ty-section');
    const codeBox = tySection?.querySelector('.cp-box');

    if (exitPop && codeBox) {
        const promoCode = (codeBox.dataset.code || codeBox.textContent).trim();
        const useCodeBtn = tySection.querySelector('.modal-btn');
        const copyTriggers = [codeBox, useCodeBtn].filter(Boolean);

        const closePop = () => {
            exitPop.classList.remove('active');
            document.body.style.overflow = 'hidden auto';
        };

        const handleCopy = async e => {
            e.preventDefault();
            await copyToClipboard(promoCode);
            codeBox.classList.add('copied');
            showToast(`Code ${promoCode} copied!`);
            setTimeout(closePop, 500);
        };

        copyTriggers.forEach(trigger => trigger.addEventListener('click', handleCopy, false));
    }
})

